export const data = {
    name: "Permits",
    layout: [],
};
export default data;